import React from "react";
import Appointment from '../Appointment'

export const AppointmentMember = ({member_id}) => {
  return (
<Appointment FromMember={member_id}/>
  )
}
